let audioCtx = null;
const lastPlayed = {};
const COOLDOWN_MS = 1500;

export const VOLUME_LEVELS = { low: 0.25, medium: 0.55, high: 0.9 };

function getCtx() {
  if (!audioCtx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    audioCtx = new AC();
  }
  if (audioCtx.state === 'suspended') audioCtx.resume();
  return audioCtx;
}

function canPlay(key) {
  const now = Date.now();
  if (lastPlayed[key] && now - lastPlayed[key] < COOLDOWN_MS) return false;
  lastPlayed[key] = now;
  return true;
}

function tone(ctx, freq, startAt, duration, gainVal, type = 'sine') {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(gainVal, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.05);
}

export function playNewOrder(volume = 0.55) {
  if (!canPlay('new-order')) return;
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 659.25, t, 0.18, volume);
    tone(ctx, 880, t + 0.16, 0.28, volume);
  } catch (e) { /* audio unavailable */ }
}

export function playNotification(volume = 0.45) {
  if (!canPlay('notification')) return;
  try {
    const ctx = getCtx();
    tone(ctx, 987.77, ctx.currentTime, 0.22, volume);
  } catch (e) { /* audio unavailable */ }
}

export function playCritical(volume = 0.8) {
  if (!canPlay('critical')) return;
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 880, t, 0.14, volume, 'square');
    tone(ctx, 880, t + 0.2, 0.14, volume, 'square');
    tone(ctx, 1174.66, t + 0.4, 0.24, volume, 'square');
  } catch (e) { /* audio unavailable */ }
}

export function playTest(volume = 0.55) {
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 659.25, t, 0.15, volume);
    tone(ctx, 880, t + 0.14, 0.22, volume);
  } catch (e) { /* audio unavailable */ }
}

export function unlockAudio() {
  try { getCtx(); } catch (e) { /* ignore */ }
}
